import { CallLlmStep, FileExtractionStep } from '../actionSectionTypes';

// note also used by File Extraction as the object models match
export const callLLMRemoveVariable = (
  step: CallLlmStep | FileExtractionStep,
  variableName: string,
  errorIds: string[]
) => {
  const nextErrorIds: string[] = [];

  if (
    step.details.destinationField === 'variable' &&
    step.details.destinations[0]?.variable?.label === variableName
  ) {
    if (!nextErrorIds.includes(step.id)) {
      nextErrorIds.push(step.id);
    }

    const destination = step.details.destinations[0];

    return {
      nextStep: {
        ...step,
        details: {
          ...step.details,
          destinations: [
            {
              ...destination,
              variable: { ...(destination.variable ?? {}), deleted: true },
            },
          ],
        },
        hasError: true,
      },
      nextErrorIds,
    };
  }
  return { nextStep: step, nextErrorIds: [] };
};
